import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingController, AlertController, Platform } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { JwPaginationModule } from 'jw-angular-pagination';
import { DataService } from '../services/dataService/data.service';


@Component({
  selector: 'app-business-list',
  templateUrl: './business-list.page.html',
  styleUrls: ['./business-list.page.scss'],
})
export class BusinessListPage implements OnInit {
  // ALi Hasan
  businessList: any;
  limit = 10;
  offset = 0;
  term: string;
  // ALi Hasan
  slidesOptions = {
    slidesPerView: 2.6,
  };
  showGallery: boolean = false;
  showReviews: boolean = false;
  newId: any;
  galId: any;
  searchRest: any;
  search: boolean = false;
  searchItems: any;
  new: any;
  constructor(
    private dataService: DataService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private business: UserApiService,
    private router: Router,
    private route: ActivatedRoute,
    
    private platform:Platform,
  ) {}

  ngOnInit() {
    this.getBusinesses();
    // this.getAllBusiness(this.limit, this.offset);
   
  }

  openGallery(id) {
    this.galId = id;
    this.newId = undefined;
    // if(this.showGallery==false){
    //   this.showGallery=true
    //   this.showReviews=false;
    // }else{
    //   this.showGallery=false;
    // }
  }

  openReviews(id) {
    this.newId = id;
    this.galId = undefined;
    // if(this.showReviews==false){
    //   this.showReviews=true
    //   this.showGallery=false;
    // }else{
    //   this.showReviews=false;
    // }
    if (this.newId != undefined) {
    }
  }

  closeAll() {
    this.newId = undefined;
    this.galId = undefined;
    // this.showReviews=false;
    // this.showGallery=false;
  }

  //search
  async setFilteredRest() {
    this.search = true;

    const loading = await this.loadingCtrl.create({
      message: 'Finding..',
    });
    // loading.present().then(() => {
    await loading.present();
    console.log('Search Keyword', this.searchRest);
    loading.dismiss();
    if (this.searchRest != '') {
      this.searchItems = this.filterItems(this.searchRest);
      loading.dismiss();
      //storing list to a new array

      this.businessList = this.searchItems;
      console.log('searched List ', this.searchItems);
    } else if (this.searchRest == '') {
      // this.getAllBusiness(this.limit, this.offset);
      // this.getBusinesses();
      loading.dismiss();
      this.searchItems = [];
      this.businessList = this.new;
      console.log(this.businessList);
    }
    // });
  }

  filterItems(searchTerm) {
    return this.businessList.filter((item) => {
      console.log('Item ', item);
      return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }

  emptySearch() {
    // console.log(ev,'works')
    this.search = false;
    this.searchItems = [];
  }

  async getAllBusiness(limit?: any, offset?: any) {
    const loading = await this.loadingCtrl.create({
      message: 'Fetching  ...',
    });
    await loading.present();

    this.business.getBusiness().subscribe(
      async (response) => {
        if (response.status) {
          loading.dismiss();
          this.businessList = response.results;
          this.new = response.results;
          console.log('businessList Length:', this.businessList.length);
          console.log('businessList:', this.businessList);
        } else {
          const alert = await this.alertCtrl.create({
            header: 'Something Went Wrong',
            message: '',
            buttons: ['OK'],
          });
          await alert.present();
          loading.dismiss();
        }
      },
      async (error) => {
        const alert = await this.alertCtrl.create({
          header: error,
          message: '',
          buttons: ['OK'],
        });
        await alert.present();
        loading.dismiss();
      }
    );
  }

  getBusinesses() {
    this.business.getBusiness().subscribe(
      async (response) => {
        if (response.status) {
          // this.businessList = '';
          // this.collection = response.results;
          this.businessList = response.results;
          this.new = response.results;
          console.log('businessList:', this.businessList.length);
        } else {
          console.log('Something Went Wrong!');
        }
      },
      async (error) => {
        console.log(error);
      }
    );
  }

  goToBusinessDetail(businessData) {
    this.dataService.setData(businessData.business_id, businessData);
    this.router.navigateByUrl('business-details/' + businessData.business_id);
  }
  openMenu(menu, id) {
    console.log(menu, id);
  }
  goToReviews(data) {
  
    this.router.navigate(['/reviews']);
  }
  goToGallery(data) {

    this.router.navigate(['/gallery']);
  }
}
